function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#CBCBCB"
}, React.createElement("path", {
  d: "M16.73 14.575H5.27c-.633 0-1.145.86-1.145 1.925s.512 1.925 1.146 1.925h11.458c.634 0 1.146-.86 1.146-1.925s-.512-1.925-1.146-1.925zm-10.657-3.85h19.48c1.076 0 1.947-.86 1.947-1.925s-.87-1.925-1.948-1.925H6.072c-1.076 0-1.947.86-1.947 1.925s.87 1.925 1.948 1.925zm8.766 11.55h-9.74c-.539 0-.974.86-.974 1.925s.435 1.925.974 1.925h9.74c.538 0 .973-.86.973-1.925s-.435-1.925-.973-1.925zM25.438 15.125c-3.418 0-6.188 2.77-6.188 6.188 0 3.417 2.77 6.187 6.188 6.187 3.417 0 6.187-2.77 6.187-6.188 0-3.417-2.77-6.187-6.188-6.187zm0 1.375c2.423 0 4.422 1.786 4.812 4.125h-2.515c-.337-.959-1.233-1.65-2.297-1.65-1.065 0-1.96.691-2.298 1.65h-2.515c.39-2.339 2.389-4.125 4.813-4.125zm-.688 9.625c-2.11-.355-3.769-2.017-4.125-4.125h2.596c.253.713.814 1.273 1.529 1.526v2.599zM25.438 22c-.38 0-.688-.307-.688-.688 0-.38.307-.687.688-.687.38 0 .687.307.687.688 0 .38-.307.687-.688.687zm.687 4.125v-2.599c.715-.253 1.276-.813 1.53-1.526h2.595c-.356 2.108-2.014 3.77-4.125 4.125z"
}));

var SvgKierowca = function SvgKierowca(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKierowca, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kierowca.9aeaa020.svg";
export { ForwardRef as ReactComponent };